import { render, staticRenderFns } from "./CaseFileDisplay.vue?vue&type=template&id=aece5d48&scoped=true&"
import script from "./CaseFileDisplay.vue?vue&type=script&lang=ts&"
export * from "./CaseFileDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFileDisplay.vue?vue&type=style&index=0&id=aece5d48&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aece5d48",
  null
  
)

export default component.exports